<template>
  <div class="enrolment-step1-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="intro-card">
        <!-- 수정일 땐 수강신청 홈페이지 수정 으로 변경  -->
        <p v-if="regist.param.idxLeSiteMain" class="mb-2 text-[15px] font-semibold text-slate-900">수강신청 홈페이지 등록</p>
        <p v-else class="mb-2 text-[15px] font-semibold text-slate-900">수강신청 홈페이지 수정</p>
        <p class="text-sm text-slate-600">[ <span class="font-bold text-red-500">*</span> ] 표시는 필수 입력사항입니다.</p>
      </section>

      <section class="section-card">
        <p class="section-title">기관 정보</p>
        <ul class="form-list">
          <li class="field-row">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 법인구분</p>
            <div class="field-content">
              <select v-model="regist.param.corporation" class="form-control">
                <option value="0" selected>법인구분</option>
                <option value="carrot global">Carrot Global</option>
                <option value="carrot edu">Carrot Edu</option>
                <option value="carrot solutions">Carrot Solutions</option>
              </select>
            </div>
          </li>
          <li class="field-row">
            <p class="field-label"><span class="font-bold text-red-500">*</span> Company</p>
            <div class="field-content">
              <div class="company-selector-wrap">
                <BagicCompanySelector :kname="regist.param.kname" @company-click="regist.setCompany" />
              </div>
            </div>
          </li>
          <li class="field-row field-row-start">
            <p class="field-label"><span class="font-bold text-red-500">*</span> Company 로고</p>
            <div class="field-content upload-stack">
              <input type="file" name="companyLogo" class="file-input" @change="(event) => regist.fileChange(event, 'companyLogo')" />
              <div v-if="regist.param.companyLogo" class="file-row">
                <input
                  class="file-name-input"
                  readonly
                  type="text"
                  :value="regist.setImageFileName(regist.param.companyLogo)"
                  @click="imgDownload(regist.param.companyLogo)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('companyLogo')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
              <p class="helper-text">※ 권장 업로드 사이즈 : 150px * 50px</p>
            </div>
          </li>
        </ul>
      </section>

      <section class="section-card">
        <p class="section-title">홈페이지 메인 이미지</p>
        <ul class="form-list">
          <li class="field-row field-row-start">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 메인 이미지</p>
            <div class="field-content upload-stack">
              <input type="file" name="mainImg" class="file-input" @change="(event) => regist.fileChange(event, 'mainImg')" />
              <div v-if="regist.param.mainImg" class="file-row">
                <input
                  class="file-name-input"
                  readonly
                  type="text"
                  :value="regist.setImageFileName(regist.param.mainImg)"
                  @click="imgDownload(regist.param.mainImg)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('mainImg')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text text-red-500">※ 권장 업로드 사이즈 : 2280px * 680px</p>
            </div>
          </li>
        </ul>
      </section>

      <section class="section-card">
        <p class="section-title">홈페이지 팝업 등록</p>
        <ul class="popup-grid">
          <li class="popup-item">
            <p class="field-label">팝업 등록1</p>
            <div class="field-content upload-stack">
              <input type="file" name="popupImg1" class="file-input" @change="(event) => regist.fileChange(event, 'popupImg1')" />
              <div v-if="regist.param.popupImg1" class="file-row">
                <input
                  readonly
                  class="file-name-input"
                  type="text"
                  :value="regist.setImageFileName(regist.param.popupImg1)"
                  @click="imgDownload(regist.param.popupImg1)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('popupImg1')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
            </div>
          </li>
          <li class="popup-item">
            <p class="field-label">팝업 등록2</p>
            <div class="field-content upload-stack">
              <input type="file" name="popupImg2" class="file-input" @change="(event) => regist.fileChange(event, 'popupImg2')" />
              <div v-if="regist.param.popupImg2" class="file-row">
                <input
                  readonly
                  class="file-name-input"
                  type="text"
                  :value="regist.setImageFileName(regist.param.popupImg2)"
                  @click="imgDownload(regist.param.popupImg2)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('popupImg2')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
            </div>
          </li>
          <li class="popup-item">
            <p class="field-label">팝업 등록3</p>
            <div class="field-content upload-stack">
              <input type="file" name="popupImg3" class="file-input" @change="(event) => regist.fileChange(event, 'popupImg3')" />
              <div v-if="regist.param.popupImg3" class="file-row">
                <input
                  readonly
                  class="file-name-input"
                  type="text"
                  :value="regist.setImageFileName(regist.param.popupImg3)"
                  @click="imgDownload(regist.param.popupImg3)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('popupImg3')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
            </div>
          </li>
          <li class="popup-item">
            <p class="field-label">팝업 등록4</p>
            <div class="field-content upload-stack">
              <input type="file" name="popupImg4" class="file-input" @change="(event) => regist.fileChange(event, 'popupImg4')" />
              <div v-if="regist.param.popupImg4" class="file-row">
                <input
                  readonly
                  class="file-name-input"
                  type="text"
                  :value="regist.setImageFileName(regist.param.popupImg4)"
                  @click="imgDownload(regist.param.popupImg4)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('popupImg4')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
            </div>
          </li>
          <li class="popup-item">
            <p class="field-label">팝업 등록5</p>
            <div class="field-content upload-stack">
              <input type="file" name="popupImg5" class="file-input" @change="(event) => regist.fileChange(event, 'popupImg5')" />
              <div v-if="regist.param.popupImg5" class="file-row">
                <input
                  readonly
                  class="file-name-input"
                  type="text"
                  :value="regist.setImageFileName(regist.param.popupImg5)"
                  @click="imgDownload(regist.param.popupImg5)"
                />
                <button class="inline-action-button" @click="regist.deleteImage('popupImg5')">Delete</button>
              </div>
              <p class="helper-text">※ jpg, png 파일만 등록 가능</p>
              <p class="helper-text">※ 해당 이미지 크기는 KB(킬로바이트)만 업로드 가능</p>
            </div>
          </li>
        </ul>
      </section>

      <section class="section-card">
        <p class="section-title">수강신청 바로가기 버튼</p>
        <ul class="option-group">
          <li class="option-item">
            <label class="option-label">
              <input type="radio" v-model="regist.param.isButton" value="Y" />
              <span>사용함</span>
            </label>
          </li>
          <li class="option-item">
            <label class="option-label">
              <input type="radio" v-model="regist.param.isButton" value="N" />
              <span>사용안함</span>
            </label>
          </li>
        </ul>
        <ul class="form-list">
          <li class="field-row field-row-divider">
            <p class="field-label">Button 1</p>
            <ul class="button-form-list">
              <li class="sub-field-row">
                <p class="sub-field-label">버튼명 :</p>
                <input
                  v-model="regist.param.button1Name"
                  type="text"
                  placeholder="Ex) Jnior 수강신청 바로가기"
                  class="form-control wide-control"
                />
              </li>
              <li class="sub-field-row">
                <p class="sub-field-label">링크 :</p>
                <input
                  v-model="regist.param.button1Link"
                  type="text"
                  placeholder="Ex) carrotjunior.kr"
                  class="form-control wide-control"
                />
              </li>
            </ul>
          </li>
          <li class="field-row field-row-divider">
            <p class="field-label">Button 2</p>
            <ul class="button-form-list">
              <li class="sub-field-row">
                <p class="sub-field-label">버튼명 :</p>
                <input
                  v-model="regist.param.button2Name"
                  type="text"
                  placeholder="Ex) Jnior 수강신청 바로가기"
                  class="form-control wide-control"
                />
              </li>
              <li class="sub-field-row">
                <p class="sub-field-label">링크 :</p>
                <input
                  v-model="regist.param.button2Link"
                  type="text"
                  placeholder="Ex) carrotjunior.kr"
                  class="form-control wide-control"
                />
              </li>
            </ul>
          </li>
          <li class="field-row field-row-divider">
            <p class="field-label">Button 3</p>
            <ul class="button-form-list">
              <li class="sub-field-row">
                <p class="sub-field-label">버튼명 :</p>
                <input
                  v-model="regist.param.button3Name"
                  type="text"
                  placeholder="Ex) Jnior 수강신청 바로가기"
                  class="form-control wide-control"
                />
              </li>
              <li class="sub-field-row">
                <p class="sub-field-label">링크 :</p>
                <input
                  v-model="regist.param.button3Link"
                  type="text"
                  placeholder="Ex) carrotjunior.kr"
                  class="form-control wide-control"
                />
              </li>
            </ul>
          </li>
          <li class="field-row">
            <p class="field-label">Button 4</p>
            <ul class="button-form-list">
              <li class="sub-field-row">
                <p class="sub-field-label">버튼명 :</p>
                <input
                  v-model="regist.param.button4Name"
                  type="text"
                  placeholder="Ex) Jnior 수강신청 바로가기"
                  class="form-control wide-control"
                />
              </li>
              <li class="sub-field-row">
                <p class="sub-field-label">링크 :</p>
                <input
                  v-model="regist.param.button4Link"
                  type="text"
                  placeholder="Ex) carrotjunior.kr"
                  class="form-control wide-control"
                />
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <section class="section-card">
        <p class="section-title"><span class="font-bold text-red-500">*</span> 메인페이지 컨텐츠 선택</p>
        <ul class="option-group">
          <li class="option-item">
            <label class="option-label" for="content1">
              <input v-model="regist.param.mainContent" type="radio" name="content" id="content1" value="junior" />
              <span>주니어 수강신청</span>
            </label>
          </li>
          <li class="option-item">
            <label class="option-label" for="content2">
              <input v-model="regist.param.mainContent" type="radio" name="content" id="content2" value="adult" />
              <span>주니어 + 성인(20세 이상) 수강신청</span>
            </label>
          </li>
        </ul>
      </section>

      <section v-if="!regist.classUpdate" class="action-card">
        <div class="flex justify-end">
          <p class="action-button" @click="regist.classAddHomePage(true)">다음 페이지 (저장)</p>
        </div>
      </section>
      <section v-if="regist.classUpdate" class="action-card">
        <div class="flex justify-end">
          <p class="action-button" @click="regist.classAddHomePage(false)">다음 페이지 (수정)</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "@/plugins/axios.js";
import BagicCompanySelector from "@/components/BagicCompanySelector.vue";

export default {
  components: {
    BagicCompanySelector,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const idxLeSiteMain = route.query.idxLeSiteMain || "0";

    const regist = reactive({
      param: {
        corporation: "0", //회사명 (문자열)
        kname: "", //회사 이름
        idxCompany: "", // 회사 인덱스 (정수)
        companyLogo: "", //로고 경로 (문자열)
        mainImg: "", //이미지 경로 (문자열)
        popupImg1: "", //팝업 경로1 (문자열)
        popupImg2: "", //팝업 경로2 (문자열)
        popupImg3: "", //팝업 경로3 (문자열)
        popupImg4: "", //팝업 경로4 (문자열)
        popupImg5: "", //팝업 경로5 (문자열)
        button1Name: "", //버튼1 이름 (문자열)
        button1Link: "", //버튼1 경로 (문자열)
        button2Name: "", //버튼2 이름 (문자열)
        button2Link: "", //버튼2 경로 (문자열)
        button3Name: "", //버튼3 이름 (문자열)
        button3Link: "", //버튼3 경로 (문자열)
        button4Name: "", //버튼4 이름 (문자열)
        button4Link: "", //버튼4 경로 (문자열)
        mainContent: "", //메인페이지 컨텐츠 (문자열)
        idxLeSiteMain: idxLeSiteMain, //idxLeSiteMain값 (정수)
        idxLeSugang: "",
        isButton: "",
      },

      classUpdate: false,

      fileChange: async (event, fieldName) => {
        const inputField = event.target;
        const file = inputField.files[0]; // 선택된 파일
        if (file) {
          try {
            const res = await regist.uploadFile(file);
            regist.param[fieldName] = res.data.data.uploadUrl;
          } catch (err) {
            console.error(err);
          }
        }
      },

      uploadFile: async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const res = await axios.post(`/admin/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          return res;
        } catch (err) {
          throw err;
        }
      },

      deleteImage(fieldName) {
        regist.param[fieldName] = "";
        const inputField = document.querySelector(`input[name="${fieldName}"]`);
        inputField.value = "";
      },

      setImageFileName(url) {
        if (url) {
          const parts = url.split("/");
          return parts[parts.length - 1];
        }
        return "";
      },

      setCompany(companyArr) {
        regist.param.idxCompany = companyArr.idxCompany;
      },

      // 수강 홈페이지 조회
      getSugangHomePage() {
        const idxLeSiteMain = route.query.idxLeSiteMain;

        if (idxLeSiteMain && idxLeSiteMain !== "0") {
          const params = {
            idxLeSiteMain: idxLeSiteMain,
          };
          axios.get(`/admin/sugangHomePage`, { params }).then(function (res) {
            if (res.data.success) {
              regist.param = res.data.data;
              regist.param.isButton = res.data.data.isButton;
              regist.classUpdate = true;
            } else {
              // 처리 실패 시의 동작
            }
          });
        }
      },

      // 수강 홈페이지 등록
      classAddHomePage() {
        // const params = regist.param;

        // 필수 입력값 체크
        if (!regist.param.corporation || regist.param.corporation === "0") {
          alert("법인구분을 선택해주세요.");
          return;
        }

        if (!regist.param.idxCompany) {
          alert("Company를 선택해주세요.");
          return;
        }

        if (!regist.param.companyLogo) {
          alert("Company 로고를 등록 해주세요.");
          return;
        }

        if (!regist.param.mainImg) {
          alert("메인 이미지를 등록 해주세요.");
          return;
        }

        if (!regist.param.mainContent) {
          alert("메인페이지 컨텐츠를 선택해주세요.");
          return;
        }

        const params = {
          ...route.query,
          ...regist.param,
          isButton: regist.param.isButton,
        };

        axios.post(`/admin/sugangHomePage`, params, {}).then(function (res) {
          if (res.data.success) {
            regist.param.idxLeSiteMain = res.data.data.idxLeSiteMain;
            regist.param.idxLeSugang = res.data.data.idxLeSugang;

            if (regist.classUpdate && !regist.param.idxLeSugang) {
              alert("수정되었습니다.");
              router.push({
                name: "enrolmentStep2",
                query: {
                  idxLeSiteMain: route.query.idxLeSiteMain,
                },
              });
            } else if (!regist.classUpdate && !regist.param.idxLeSugang) {
              alert("등록되었습니다.");
              router.push({
                name: "enrolmentStep2",
                query: {
                  idxLeSiteMain: regist.param.idxLeSiteMain,
                },
              });
            } else {
              alert("수정되었습니다.");
              router.push({
                name: "enrolmentStep2",
                query: {
                  idxLeSugang: regist.param.idxLeSugang,
                },
              });
            }

            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
      },
    });

    const imgDownload = (url) => {
      window.open(url, "_blank");
    };

    onMounted(() => {
      regist.getSugangHomePage();
    });

    return {
      regist,
      idxLeSiteMain,
      imgDownload,
    };
  },
};
</script>
<style scoped>
.enrolment-step1-page {
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.intro-card,
.section-card,
.action-card {
  margin: 0 auto;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.section-title {
  margin-bottom: 1rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.form-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.field-row-start {
  align-items: flex-start;
}

.field-row-divider {
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.field-label {
  flex: none;
  width: 9rem;
  padding-top: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.field-content {
  flex: 1;
  min-width: 0;
}

.company-selector-wrap {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.form-control,
.enrolment-step1-page select,
.enrolment-step1-page input[type="text"] {
  height: 2.875rem;
  min-width: 14rem;
  border: 1px solid #cbd5e1 !important;
  border-radius: 0.75rem;
  background-color: #fff;
  padding: 0.7rem 0.9rem;
  font-size: 0.95rem;
  color: #0f172a;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.form-control:focus,
.enrolment-step1-page select:focus,
.enrolment-step1-page input[type="text"]:focus {
  border-color: #94a3b8 !important;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.wide-control {
  width: 100%;
  max-width: 42rem;
  min-width: 0;
}

.upload-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
}

.file-input,
.enrolment-step1-page input[type="file"] {
  display: block;
  width: 100%;
  max-width: 28rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.65rem 0.9rem;
  color: #334155;
}

.file-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.file-name-input {
  height: 2.875rem;
  width: 100%;
  max-width: 24rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.7rem 0.9rem;
  color: #2563eb;
  cursor: pointer;
}

.inline-action-button,
.enrolment-step1-page button {
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.65rem 0.95rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #475569;
  transition: background-color 0.2s ease;
}

.inline-action-button:hover,
.enrolment-step1-page button:hover {
  background: #f8fafc;
}

.helper-text {
  font-size: 0.8125rem;
  color: #64748b;
}

.popup-grid {
  display: grid;
  gap: 1rem;
}

.popup-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #f8fafc;
}

.option-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.option-item {
  list-style: none;
}

.option-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 2.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  color: #334155;
  cursor: pointer;
}

.button-form-list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
}

.sub-field-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.sub-field-label {
  flex: none;
  width: 4.5rem;
  font-size: 0.85rem;
  color: #64748b;
}

.action-button {
  display: inline-flex;
  min-height: 2.875rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #475569;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.action-button:hover {
  background: #f8fafc;
}

.enrolment-step1-page input[type="radio"] {
  accent-color: #2563eb;
}

@media (max-width: 1023px) {
  .field-row,
  .popup-item,
  .sub-field-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .field-label,
  .sub-field-label {
    width: 100%;
    padding-top: 0;
  }

  .option-group {
    flex-direction: column;
  }
}

@media (min-width: 1024px) {
  .popup-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
